import React from 'react';
import ErrorLayout from './ErrorLayout';

import style from './style.css';
import locationNotCovered from './img/location-not-covered.svg';

const messages = {
  errorTitle: { id: 'SEARCH_RESULTS.COVERED_ERROR.TITLE' },
  errorMessage: { id: 'SEARCH_RESULTS.COVERED_ERROR.MESSAGE' }
};

export const CoveredError = (props) => {
  const image = <img className={style.image} src={locationNotCovered} alt="error" />;

  return (
    <ErrorLayout
      {...props}
      titleMessage={messages.errorTitle}
      message={messages.errorMessage}
      image={image}
    />
  );
};

// TODO: move to Flow types
// CoveredError.propTypes = {
//   className: PropTypes.string,
//   mobile: PropTypes.bool
// };

export default CoveredError;
